import { render } from "./dpList.vue?vue&type=template&id=405ac97c"
import script from "./dpList.vue?vue&type=script&lang=js"
export * from "./dpList.vue?vue&type=script&lang=js"

import "./dpList.vue?vue&type=style&index=0&id=405ac97c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__